import { styled } from '@vebox/etui-system';
import { useState, useEffect, Children, createElement, cloneElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';

const _excluded = ["theme"];
const AccordionDiv = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    bg: 'inherit',
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSizeBase,
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: theme.typography.lineHeightBase
  }, rest);
})``;

const Accordion = ({
  styles = {},
  children,
  onSectionToggle,
  enableSingleSectionOpen
}) => {
  const [openSections, setOpenSections] = useState({});
  useEffect(() => {
    const newOpenSections = _objectSpread2({}, openSections);
    Children.toArray(children).forEach(child => {
      if (child && !Object.prototype.hasOwnProperty.call(newOpenSections, child.props.name)) {
        newOpenSections[child.props.name] = !!child.props.defaultOpen;
      }
    });
    setOpenSections(newOpenSections);
  }, [Children.toArray(children).map(child => child.props.name).join(',')]);
  const handleToggle = label => {
    const isOpen = !!openSections[label];
    if (enableSingleSectionOpen) {
      const newSectionObj = _objectSpread2({}, openSections);
      Object.keys(newSectionObj).forEach(key => {
        if (key === label) {
          newSectionObj[key] = !isOpen;
        } else {
          newSectionObj[key] = false;
        }
      });
      setOpenSections(newSectionObj);
    } else {
      setOpenSections(prevOpenSections => _objectSpread2(_objectSpread2({}, prevOpenSections), {}, {
        [label]: !isOpen
      }));
    }
    if (onSectionToggle) {
      onSectionToggle(label, !isOpen);
    }
  };
  return /*#__PURE__*/createElement(AccordionDiv, _extends({
    "data-component": "Accordion"
  }, styles.root), Children.toArray(children).filter(c => c).map(child => /*#__PURE__*/cloneElement(child, {
    isOpen: !!openSections[child.props.name],
    onToggle: handleToggle
  })));
};

export default Accordion;
